import React from "react"
import { Row, Col } from "reactstrap"
import { Field } from "redux-form"
import { TextField } from "components/RenderInput"

export const renderListItemButtons = ({ fields, listItem }) => {
  return (
    <>
      <Row className="my-2">
        <Col xl={5}>
          <h6>Button name (optional)</h6>
        </Col>
        <Col xl={7}>
          <h6>Button Link (optional)</h6>
        </Col>
      </Row>
      {fields.map((button, index) => (
        <Row key={index} className="my-2">
          <Col xl={5}>
            <Field
              name={`${button}.name`}
              component={TextField}
              placeholder="Add button name here"
            />
          </Col>
          <Col xl={6}>
            <Field
              name={`${button}.link`}
              component={TextField}
              placeholder="This can be an URL (include http:// or https://), a phone number or an email address"
            />
          </Col>
          <Col xl={1}>
            <i
              className="bx bx-sm bx-x"
              style={{
                paddingTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                fields.remove(index)
              }}
            />
          </Col>
        </Row>
      ))}
      <Row>
        <Col>
          <p
            style={{ cursor: "pointer" }}
            onClick={() => fields.push({ name: "", link: "" })}
          >
            + Add Another Button
          </p>
        </Col>
      </Row>
    </>
  )
}
